export enum DexTrancheDetailsFeature {
    COLLAPSED                = 'COLLAPSED',
    SUPPORTS_EXPAND_COLLAPSE = 'SUPPORTS_EXPAND_COLLAPSE'
}

export type DexTrancheDetailsFeatures = Partial<Record<DexTrancheDetailsFeature, true>>;
